// extracted by mini-css-extract-plugin
module.exports = {"servicesWrapper":"_3e3AG","thumbnailContainer":"_3LzJw"};